import request from '@@/utils/request'

// 交易信息 列表
export function selectByWebUrl(params) {
  return request({
    url: '/zb/platformsettings/selectByWebUrl',
    method: 'get',
    headers: {
      isToken: false
    },
    params
  })
}